<!--  -->
<template>
  <div class="cen">
    <div class="bai">
      <el-form
        :model="ruleForm2"
        status-icon
        ref="ruleForm2"
        class="demo-ruleForm101"
      >
        <div class="left_form">
          <el-form-item label="手机号：" prop="phone">
            <el-input
              placeholder="请输入手机号"
              maxlength="11"
              v-model="ruleForm2.phone"
              class="input"
            ></el-input>
          </el-form-item>
          <div class="code_box1">
            <el-form-item
              label="验证码："
              prop="verification"
              :rules="rulesUtils.verification"
            >
              <el-input
                placeholder="请输入验证码"
                maxlength="6"
                v-model="ruleForm2.verification"
                class="code1"
              ></el-input>
            </el-form-item>
            <el-button
              type="primary"
              @click="sendSms()"
              class="zchqyzm"
              v-show="!disabled"
              :disabled="disabled"
              >{{ content }}</el-button
            >
            <el-button
              type="primary"
              @click="sendSms()"
              class="but4"
              v-show="disabled"
              :disabled="disabled"
              >{{ content }}</el-button
            >
          </div>

          <el-form-item label="登录密码：" prop="password">
            <el-input
              type="password"
              placeholder="密码必须由数字、字母、特殊字符组合,请输入8-20位"
              maxlength="20"
              v-model="ruleForm2.password"
              auto-complete="off"
              class="input"
              show-password
            ></el-input>
          </el-form-item>

          <el-form-item label="再次输入密码：" prop="checkPass">
            <el-input
              type="password"
              placeholder="密码必须由数字、字母、特殊字符组合,请输入8-20位"
              maxlength="20"
              v-model="ruleForm2.checkPass"
              auto-complete="off"
              class="input"
              show-password
            ></el-input>
          </el-form-item>
          <el-button type="primary" @click="resetForm('ruleForm2')" class="but2"
            >取消</el-button
          >
          <el-button
            type="primary"
            @click="submitForms('ruleForm2')"
            class="but1"
            :loading="codeDisabled"
            >提交</el-button
          >
        </div>
      </el-form>
    </div>
    <notices></notices>
  </div>
</template>
  
  <script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import "element-ui/lib/theme-chalk/index.css";
// import { reg, verification } from "@/api/reg";
import { getyzm, uppassword } from "@/api/news";
import rules from "@/utils/rules";
import notices from "../components/notices.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm2.checkPass !== "") {
          this.$refs.ruleForm2.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm2.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      disabled: false,
      codeDisabled: false,
      interval: undefined,
      totalCount: 0,
      rulesUtils: rules,
      show: false, //注册成功弹窗
      ruleForm2: {
        phone: "",
        name: "",
        id_card: "",
        password: "",
        checkPass: "",
        verification: "",
      },
      SendMsgForm: {
        telephone: "",
        type: 1,
      },
      flag: false,
      //   rules2: {
      //     password: [
      //       { min: 8, max: 20, message: "长度在 8 到 20 个字符" },
      //       {
      //         pattern: /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}/,
      //         message: "密码必须由数字、字母、特殊字符组合,请输入8-20位",
      //       },
      //       { validator: validatePass, trigger: "blur" },
      //     ],
      //     checkPass: [
      //       { min: 8, max: 20, message: "长度在 8 到 20 个字符" },
      //       {
      //         pattern: /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}/,
      //         message: "密码必须由数字、字母、特殊字符组合,请输入8-20位",
      //       },
      //       { validator: validatePass2, trigger: "blur" },
      //     ],
      //     verification: [
      //       { required: true, message: "请输入验证码", trigger: "blur" },
      //     ],
      //     name: [
      //       { required: true, message: "请输入用户名", trigger: "blur" },
      //       { min: 2, max: 7, message: "长度在 2 到 7 个字符" },
      //       { pattern: /^[\u4E00-\u9FA5]+$/, message: "用户名只能为中文" },
      //     ],
      //     phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
      //   },
    };
  },
  //监听属性 类似于data概念
  computed: {
    content() {
      return this.totalCount !== 0 ? `${this.totalCount}秒` : "获取验证码";
    },
  },
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //方法集合
  methods: {
    //用户须知公共弹窗
    login() {
      this.$router.push("/login");
    },
    tan() {
      this.$notice(true);
    },
    ok() {
      this.show = false;
      this.$router.push("/login");
    },
    sendSms() {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (this.ruleForm2.phone === "") {
        return this.$toast("获取验证码失败，手机号为空!");
      } else if (!reg.test(this.ruleForm2.phone)) {
        return this.$toast("手机号格式不正确!");
      }
      // 按钮60秒倒计时
      this.disabled = true;
      this.totalCount = 60;
      this.getyzm(); // 60秒过倒计时过后才能调用的事件
      this.interval = setInterval(() => {
        this.totalCount--;
        if (this.totalCount === 0) {
          clearInterval(this.interval);
          this.disabled = false;
        }
      }, 1000);
    },
    //发送验证码
    async getyzm() {
      const ver = await getyzm({
        telephone: this.ruleForm2.phone,
        type: "2",
      });
      console.log(ver);
      if (ver.code == "200") {
        console.log("发送成功");
        if (ver.data.msg && ver.data.msg == "isv.BUSINESS_LIMIT_CONTROL") {
          this.$toast(
            "您好亲，同一个手机号码发送验证码，最多支持1条/分钟，5条/小时，10条/天。"
          );
        }
      } else {
        this.$toast(ver.msg);
      }
    },
    submitForm(formName) {
      this.codeDisabled = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.flag) {
            this.formSub();
          }
        } else {
          console.log("error submit!!");
          this.codeDisabled = false;
          return false;
        }
      });
    },
    submitForms() {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      const reg1 = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}/;
      if (this.ruleForm2.phone == "") {
        this.$toast("请输入手机号");
      } else if (!reg.test(this.ruleForm2.phone)) {
        this.$toast("手机号格式不正确");
      } else if (this.ruleForm2.verification == "") {
        this.$toast("请输入手机验证码");
      } else if (this.ruleForm2.password == "") {
        this.$toast("请输入登录密码");
      } else if (!reg1.test(this.ruleForm2.password)) {
        this.$toast("密码必须由数字、字母、特殊字符组合,请输入8-20位");
      } else if (this.ruleForm2.checkPass == "") {
        this.$toast("请再次输入密码");
      } else if (this.ruleForm2.checkPass != this.ruleForm2.password) {
        this.$toast("两次输入密码不一致!");
      } else {
        this.flag = true;
        this.codeDisabled = true;
        if (this.flag) {
          this.formSub();
        }
      }
    },
    async formSub() {
      const res = await uppassword({
        phone: this.ruleForm2.phone,
        verification: this.ruleForm2.verification,
        password: this.ruleForm2.password,
      });
      this.flag = false;
      if (res.code == "200") {
        this.$toast("提交成功");
        this.$router.push("/login");
      } else {
        this.$toast("提交失败," + res.msg);
      }
    },
    resetForm(formName) {
      this.$router.push("/login");
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
/*@import url(); 引入公共css类*/
.cen {
  min-height: calc(100vh - 2rem);
  background-color: #f5f5f5;

  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.bai {
  background-color: #fff;
  width: 85%;
  border-radius: 0.36rem;
  padding: 1rem 0.4rem;
  margin-top: 4rem;
}
/deep/.el-form-item {
  margin-bottom: 0rem;
}
.code_box1 {
  /deep/.el-input .el-input__inner {
    line-height: 2.12rem;
    font-size: 0.52rem;
    width: 8rem;
  }
}
.code_box1 {
  position: relative;
  display: flex;
  align-items: flex-end;
}
.zchqyzm {
  background: #0f9386;
  border: #0f9386;
  margin-left: 1rem;
  margin-bottom: 0.1rem;
  width: 4rem;
  font-size: 0.52rem;
  height: 1.5rem;
  cursor: pointer;
}
.but4 {
  background: #cbcbcb;
  border: #cbcbcb;
  margin-left: 1rem;
  margin-bottom: 0.1rem;
  width: 4rem;
  font-size: 0.52rem;
  height: 1.5rem;
  cursor: pointer;
}
.but1 {
  position: relative;
  font-size: 0.64rem;
  width: 4rem;
  height: 1.5rem;
  background: #0f9386;
  border: #0f9386;
  margin-top: 1rem;
}
.but2 {
  position: relative;
  font-size: 0.64rem;
  width: 4rem;
  height: 1.5rem;
  background: #b8b8b8;
  margin-right: 0.8rem;
  border: #b8b8b8;
  margin-top: 1rem;
}
/deep/.el-input {
  font-size: 0.48rem;
}
</style>